'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.changeMoreItemsFromCatalogIndex = exports.getMoreItemsFromCatalogIndex = exports.CHANGE_MORE_ITEMS_FROM_CATALOG_INDEX = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

exports.default = reducer;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var CHANGE_MORE_ITEMS_FROM_CATALOG_INDEX = exports.CHANGE_MORE_ITEMS_FROM_CATALOG_INDEX = 'CHANGE_MORE_ITEMS_FROM_CATALOG_INDEX';

// reducer
var DEFAULT_STATE = {};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    switch (action.type) {
        case CHANGE_MORE_ITEMS_FROM_CATALOG_INDEX:
            return (0, _extends4.default)({}, state, (0, _defineProperty3.default)({}, action.payload.itemId, action.payload.newIndex));
        default:
            return state;
    }
}

/* SELECTORS */
var getMoreItemsFromCatalogIndex = exports.getMoreItemsFromCatalogIndex = function getMoreItemsFromCatalogIndex(state, itemId, fallbackIndex) {
    return state.ui.moreItemsFromCatalogIndex[itemId] || fallbackIndex || 0;
};

/* ACTION CREATORS */
var changeMoreItemsFromCatalogIndex = exports.changeMoreItemsFromCatalogIndex = function changeMoreItemsFromCatalogIndex(itemId, newIndex) {
    return {
        payload: { itemId: itemId, newIndex: newIndex },
        type: CHANGE_MORE_ITEMS_FROM_CATALOG_INDEX
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/moreItemsFromCatalogIndex.js
// module id = i+lj
// module chunks = 60